var $f99469db2a9ce4d6$exports = {};
$f99469db2a9ce4d6$exports = {
    "endTime": `\u{10C}as ukon\u{10D}enia`,
    "startTime": `\u{10C}as za\u{10D}iatku`,
    "time": `\u{10C}as`
};


export {$f99469db2a9ce4d6$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
